export default "__VITE_ASSET__qz2Yavd4__"